import { render, staticRenderFns } from "./FundaBNPLIntro.vue?vue&type=template&id=4ceaa74e&scoped=true&"
import script from "./FundaBNPLIntro.vue?vue&type=script&lang=js&"
export * from "./FundaBNPLIntro.vue?vue&type=script&lang=js&"
import style0 from "./FundaBNPLIntro.vue?vue&type=style&index=0&id=4ceaa74e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceaa74e",
  null
  
)

export default component.exports